import BranchBaseController from '../common/branch.base.controller'

class BranchEditController extends BranchBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, BranchService, Modal, $translate, $stateParams, WindowService, $q) {

		super(Auth, $state, User, BranchService, Modal, $translate, $stateParams)

		this.WindowService = WindowService
		this.$q = $q;

		this.model.id = ''
		this.model.description = ''
		this.businessDays = [
			{ label: 'Monday', model: 'businessDayMon' },
			{ label: 'Tuesday', model: 'businessDayTue' },
			{ label: 'Wednesday', model: 'businessDayWed' },
			{ label: 'Thursday', model: 'businessDayThu' },
			{ label: 'Friday', model: 'businessDayFri' },
			{ label: 'Saturday', model: 'businessDaySat' },
			{ label: 'Sunday', model: 'businessDaySun' },
			{ label: 'Holiday', model: 'businessDayHol' }
		];
		this.isDaySelected = (day) => this.model[day.model];
		this.toggleDay = (day) => { this.model[day.model] = !this.model[day.model]; };
	}

	$onInit() {
		this.loadData();
	}

	loadData() {
		this.Service.get(this.$stateParams.id)
			.then((data) => {
				this.rawId = data.id
				this.model.id = data.id
				this.model.description = data.description
				this.model.windows = data.windows
				this.model.windows.forEach((data) => {
					data.oldValue = data.id
				})
				this.model.businessDayMon = data.businessDayMon;
				this.model.businessDayTue = data.businessDayTue;
				this.model.businessDayWed = data.businessDayWed;
				this.model.businessDayThu = data.businessDayThu;
				this.model.businessDayFri = data.businessDayFri;
				this.model.businessDaySat = data.businessDaySat;
				this.model.businessDaySun = data.businessDaySun;
				this.model.businessDayHol = data.businessDayHol;
			})
			.catch((err) => {
				console.log(err);
			})
	}

	addWindow() {
		this.model.windows.push({
			expand: true,
			id: null,
			isSaved: false,
			description: null
		});
	}

	toggleExpand(window) {
		window.expand = !window.expand;
	}

	saveWindow(index) {
		const windowObj = this.model.windows[index];
		const windowObjData = {
			id: windowObj.id,
			description: windowObj.description,
			branchId: this.model.id,
			allowCoin: windowObj.allowCoin,
			allowCash: windowObj.allowCash,
			locationId: windowObj.locationId,
			oldValue: windowObj.oldValue
		}

		if (windowObj.branchId && windowObj.oldValue) {
			this.WindowService.update(windowObj.oldValue, windowObjData)
				.then((res) => {
					this.model.windows.splice(index, 1, res);
					windowObj.expand = false;
					windowObj.isSaved = true;
				})
				.then(() => {
					this.loadData();
				})
				.catch((err) => {
					this.errorMessage = this.$translate.instant('error.' + 90993)
					console.log(err);
				})
		}
		else {
			this.WindowService.create(windowObjData)
				.then((res) => {
					res.branchId = this.model.id;
					this.model.windows.splice(index, 1, res);
					windowObj.expand = false;
					windowObj.isSaved = true;
				})
				.then(() => {
					this.loadData();
				})
				.catch((err) => {
					err.data.errors.map((e) => {
						this.errorMessage += e.message + '<br/>'
					})
				})
		}
	}

	deleteWindow(index) {
		this.Modal.confirm({
			header: this.$translate.instant('branch.confirm'),
			message: this.$translate.instant('branch.confirm_delete_message'),
			callback: ({
				modal,
				$scope
			}) => {
				const windowObj = this.model.windows[index];

				if (windowObj.branchId) { //is already created
					this.WindowService.remove(windowObj.id)
						.then(() => {
							this.model.windows.splice(index, 1);
							modal.close()
						})
				}
				else {// is newly added
					this.model.windows.splice(index, 1);
					modal.close()
				}
			},
			negative: ({
				modal,
				$scope
			}) => {
				modal.close()
			},
			type: 'primary',
			buttons: ['common.yes', 'common.no']
		})
	}

	reset(e) {
		this.loadData();
		delete this.errorMessage;
	}

	submit(evt) {
		if (!this.validate()) {
			return
		}

		this.loading = true

		this.$q.all(
			this.model.windows
				.filter((windowObj) => {
					return windowObj.isSaved === false;
				})
				.map((windowObj) => {
					return windowObj.branchId && windowObj.oldValue ?
						this.WindowService.update(windowObj.oldValue, windowObj) :
						this.WindowService.create(Object.assign(windowObj, { branchId: this.model.id }));
				})
		)
			.then(() => {
				return this.Service.update(this.rawId, {
					id: this.model.id,
					description: this.model.description,
					businessDayMon: this.model.businessDayMon,
					businessDayTue: this.model.businessDayTue,
					businessDayWed: this.model.businessDayWed,
					businessDayThu: this.model.businessDayThu,
					businessDayFri: this.model.businessDayFri,
					businessDaySat: this.model.businessDaySat,
					businessDaySun: this.model.businessDaySun,
					businessDayHol: this.model.businessDayHol
				});
			})
			.then((data) => {
				this.loading = false
				window.history.go(-1)
			})
			.catch((err) => {
				this.loading = false
				if (err && err.data && err.data.errors) {
					err.data.errors.map((e) => {
						this.errorMessage += e.message + '<br/>'
					})
				}
				else {
					this.errorMessage = this.$translate.instant('error.' + 90993)
				}

			})

	}
}

export default BranchEditController;



// WEBPACK FOOTER //
// ./client/app/components/branch/edit/branch.edit.controller.js